// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"519ddd48","787":"0660ca02","845":"7004c449"}[chunkId] + ".chunk.js";
};